import { z } from 'zod';
import { PortalUserSchema } from '../../base/user.js';
export const GetPortalUserRequestPathSchema = z.object({
    email: z.string().transform((val) => decodeURI(val)),
});
export const GetPortalUserRequestSchema = GetPortalUserRequestPathSchema;
export const GetPortalUserResponseSchema = z.object({ users: PortalUserSchema.array() });
export const GetPortalUserApiSchema = {
    params: GetPortalUserRequestPathSchema,
    response: GetPortalUserResponseSchema,
};
